import React from 'react';
import { Select, Space } from 'antd';

const SelectTagsMultipleComponent = ({
  status,
  placeholder,
  value,
  setValue,
  textError,
  className,
  options = [],
  size,
}) => {
  const onChange = (values) => {
    setValue?.(values);
  };

  return (
    <>
      <Select
        mode="tags"
        size={size || 'large'}
        showSearch
        allowClear
        className={`w-100 ${className || ''}`}
        placeholder={placeholder || 'Select or enter tags'}
        value={value || []}
        status={status || undefined}
        options={options}
        onChange={onChange}
        filterOption={(input, option) => {
          const label = String(option?.label ?? '').toLowerCase();
          const optionValue = String(option?.value ?? '').toLowerCase();
          const searchValue = input.toLowerCase();

          return (
            label.includes(searchValue) ||
            optionValue.includes(searchValue)
          );
        }}
        optionRender={(option) => (
          <Space>
            {option.data?.emoji && (
              <span
                role="img"
                aria-label={option.data?.label}
              >
                {option.data.emoji}
              </span>
            )}

            <span>{option.data?.label}</span>
          </Space>
        )}
      />

      {textError && (
        <div
          className="ant-form-item-explain-error"
          style={{
            color: '#ff4d4f',
            marginTop: 4,
          }}
        >
          {textError}
        </div>
      )}
    </>
  );
};

export default SelectTagsMultipleComponent;